// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"d282a1be","252":"cbef9526","322":"9a9f1d86","453":"fbf1658e","462":"082f5036","967":"18a53e35"}[chunkId] + ".chunk.js";
};